<div class="module-content">
    <div class="full-sized">
        <router-outlet></router-outlet>
    </div>
</div>